import { useMemo } from 'react';
import { planCellKey } from '../../../utils/planCells';

export const useContourBorders = (
  hoveredCellKeys: Set<string>,
  selectedCellKeys: Set<string>,
) => {
  return useMemo(() => {
    const borders = new Map<string, { top: boolean; right: boolean; bottom: boolean; left: boolean }>();

    const calculateBorders = (cellKeys: Set<string>) => {
      cellKeys.forEach((key) => {
        const [rowStr, colStr] = key.split(':');
        const row = parseInt(rowStr, 10);
        const col = parseInt(colStr, 10);

        const topRow = row === 1 ? -1 : row - 1;
        const bottomRow = row === -1 ? 1 : row + 1;
        const leftCol = col === 1 ? -1 : col - 1;
        const rightCol = col === -1 ? 1 : col + 1;

        const topKey = planCellKey(topRow, col);
        const bottomKey = planCellKey(bottomRow, col);
        const leftKey = planCellKey(row, leftCol);
        const rightKey = planCellKey(row, rightCol);

        borders.set(key, {
          top: !cellKeys.has(topKey),
          bottom: !cellKeys.has(bottomKey),
          left: !cellKeys.has(leftKey),
          right: !cellKeys.has(rightKey),
        });
      });
    };

    if (hoveredCellKeys.size > 0) calculateBorders(hoveredCellKeys);
    if (selectedCellKeys.size > 0) calculateBorders(selectedCellKeys);

    return borders;
  }, [hoveredCellKeys, selectedCellKeys]);
};
